module.exports = __webpack_public_path__ + "img/home-2024.c992b7a0.png";